const templateRouters = [
  {
    path: "/app-template",
    component: () => import("@/views/Template/AppTemplate"),
    name: "app-template",
    meta: { public: true },
    children: [
      {
        path: "worksheet/:appId/:sheetId?/:viewId?",
        component: () => import("@/views/Template/SimpleWorksheet"),
        name: "app-template-worksheet",
        meta: { public: true }
      },
      {
        path: "statistics-board/:appId/:boardId",
        component: () => import("@/views/Template/SimpleDashboard"),
        name: "app-template-statistics-board",
        meta: { public: true }
      }
    ]
  }
]

export default templateRouters
